import { routes as auth } from './auth';
import { routes as alvenaria } from './alvenaria';
import { routes as error } from './error';
import { routes as gestao } from './gestao';
import { routes as utilidade } from './utilidade';
import { routes as suporte } from './suporte';
import { routes as concreto } from './concreto';
import { routes as nconaoconformidade } from './nao-conformidade';
import { routes as financeiro } from './financeiro';
import { EMAILS_ACESSO_FORNECEDOR_BASE } from '@/enums/ePermissoes';
import { PAINEIS_GABARITO, metaDoPainel, rotaDoPainel } from '@/views/dashboard/dynamic-dashboards/engine/paineis';

const routes: any[] = [
  {
    path: '/denied',
    name: 'denied',
    description: 'denied',
    component: () => import('@/views/auth/AccessDenied.vue')
  },
  {
    path: '/teste',
    name: 'teste',
    description: 'teste',
    meta: {
      requiresAuth: true,
      emailsPermitidos: EMAILS_ACESSO_FORNECEDOR_BASE
    },
    component: () => import('@/views/gestao/fornecedor/Index.vue')
  },
  {
    path: '/lockscreen',
    name: 'lockscreen',
    description: 'lockscreen',
    meta: {
      requiresAuth: false
    },
    component: () => import('@/views/lock-screen/LockScreen.vue')
  },
  {
    path: '/proxylegado/:tela',
    name: 'proxyLegado',
    description: 'legado',
    component: () => import('@/views/legado/Proxy.vue')
  },

  {
    path: '/signout',
    name: 'Signout',
    component: () => import('@/views/auth/login/SignOut.vue')
  },
  ...auth,
  {
    path: '/',
    redirect: '/home',
    name: 'home',
    description: 'home',
    meta: {
      requiresAuth: true
    },
    component: () => import('@/layout/maintemplate/MainTemplate.vue'),
    children: [
      {
        path: '/home',
        name: 'home2',
        description: 'Home',
        component: () => import('@/views/home/Index.vue')
      },
      {
        path: '/notificacoes',
        name: 'notifications',
        description: 'Notificações',
        goesToMenu: false,
        component: () => import('@/views/notifications/Index.vue')
      },
      ...error,
      ...alvenaria,
      ...gestao,
      ...utilidade,
      ...suporte,
      ...concreto,
      ...nconaoconformidade,
      ...financeiro,
      {
        path: '/:pathMatch(.*)*',
        name: '404',
        description: '404',
        goesToMenu: false,
        component: () => import('@/views/notfound/NotFound.vue')
      }
    ]
  },
  // Painéis de gestão: gabarito com menu lateral (public/paineis-gestao), fora do MainTemplate
  // (abre sozinho, numa aba nova). Entra quem pode abrir algum dos painéis; o gabarito lista só
  // os que o usuário pode abrir, e a API refaz a checagem em cada consulta do GraphQL.
  {
    path: '/paineis',
    name: 'PaineisGestao',
    component: () => import('@/views/dashboard/dynamic-dashboards/engine/PaineisHost.vue'),
    meta: {
      requiresAuth: true,
      utlTipoFornecimentoId: 1,
      permissions: [...new Set(PAINEIS_GABARITO.map(p => p.permissao))]
    }
  },
  // Endereços antigos de cada painel (/dashboards/<id>) abrem o painel no gabarito.
  ...PAINEIS_GABARITO.map(p => ({
    path: `/dashboards/${p.id}`,
    name: p.rota,
    redirect: rotaDoPainel(p.id),
    meta: metaDoPainel(p)
  }))
];

export default routes;
